import { MessageCircle } from "lucide-react";

export default function WhatsAppFloat({ whatsapp }) {
  const number = (whatsapp?.number || "").replace(/\D/g, "");
  const link = `https://wa.me/${number}?text=${encodeURIComponent(whatsapp?.message || "")}`;

  return (
    <a
      data-testid="whatsapp-float"
      href={link}
      target="_blank"
      rel="noreferrer"
      aria-label="Fale comigo no WhatsApp"
      className="group fixed bottom-24 sm:bottom-28 right-0 z-50 translate-x-[40%] hover:translate-x-0 focus:translate-x-0 transition-transform duration-300 ease-out"
    >
      <div className="relative flex items-center bg-onyx text-alabaster rounded-l-full pl-2 pr-5 py-2 shadow-2xl">
        <span className="relative inline-flex w-11 h-11 rounded-full bg-gold items-center justify-center mr-0 group-hover:mr-3 transition-all duration-300">
          <span className="absolute inset-0 rounded-full bg-gold/50 animate-ping" />
          <MessageCircle size={20} fill="currentColor" className="relative text-onyx" />
        </span>
        <span className="overflow-hidden max-w-0 group-hover:max-w-[180px] transition-[max-width] duration-300 whitespace-nowrap">
          <span className="text-xs tracking-[0.2em] uppercase font-semibold">
            {whatsapp?.floatText || "Fale Comigo"}
          </span>
        </span>
      </div>
    </a>
  );
}
